/* 🤖 this file was generated by svg-to-ts */
export const mgcIconSurfboardFilled: {
  name: 'surfboard-filled';
  data: string;
} = {
  name: 'surfboard-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.56 3.744c-1.138.097-1.699.188-2.708.437-2.803.694-5.393 2.061-7.399 3.904-2.062 1.895-3.828 4.636-4.729 7.339-.364 1.093-.443 1.515-.368 1.961.099.588.138.637 1.83 2.337 1.631 1.637 1.779 1.761 2.251 1.885.474.123.813.083 1.78-.213 2.618-.802 5.281-2.421 7.299-4.438 2.228-2.228 3.845-5.346 4.5-8.676.237-1.206.315-2.679.172-3.251-.163-.654-.514-1.021-1.143-1.196-.263-.074-1.09-.123-1.485-.089"/></svg>`
};
